export default {
  en: {
    'pages.api-page.no-entity-selected': 'Please select entity',
    'pages.api-page.amazon': 'Amazon',
    'pages.api-page.seller-id': 'Seller Id',
    'pages.api-page.mws-auth-token': 'MWS Auth Token',
    'pages.api-page.valid-status': 'Valid',
    'pages.api-page.api-valid-status': 'API Valid',
    'pages.api-page.status': 'Status',
    'pages.api-page.invalid-status': 'Invalid',
    'pages.api-page.api-invalid-status': 'API Invalid',
    'pages.api-page.update-credentials': 'Update Credentials',
    'pages.api-page.create-credentials': 'Create Credentials',
    'pages.api-page.credentials-not-found': 'Credentials could not be found.',
    'pages.api-page.coming-soon': 'This feature is coming soon',
    'pages.api-page.save': 'Save',
    'pages.api-page.add': 'Add',
  },
};
